import _ from 'lodash'
import { globalPreventRules }  from 'scoreboard/components/paste/default-paste-allowed'

/**
 * Returns whether a paste is allowed
 * @param item the node to be pasted
 * @param parent the new parent for the node (null if pasting to the top level)
 * @param emptyOrg true if the org is empty
 * @param mode either 'copy' or 'move'
 * @param org the org the destination paste occurs in
 */
function initiativesPasteAllowed(item, parent, emptyOrg, mode, org) {
	if (globalPreventRules.apply(this, arguments)) {
		return false
	}

	// anything is allowed at the top level
	if (_.isNil(parent)) {
		return true
	}
	// replicated structure cannot be modified
	if (!_.isNil(parent.syncId) || !_.isNil(item.syncId)) {
		return false
	}

	// anything is allowed under an initiative
	if (parent.type === 'initiative') {
		return true
	}
	// tasks can have tasks and milestones under them, but not initiatives
	if (parent.type === 'task') {
		return item.type != 'initiative'
	}

	// nothing is allowed under a milestone
	return false
}

export default initiativesPasteAllowed

initiativesPasteAllowed.__filename__ = 'initiatives/edit/initiatives-paste-allowed.js'
